"use strict";

class DeveloperProfileController {

  constructor($scope, $timeout, $localStorage, SSHttpService, SSUtilService, SSSearchService, SSUserService, SSAppService) {

    const self = this;

    self.$scope = $scope;
    self.$storage = $localStorage;
    self.$timeout = $timeout;
    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSSearchService = SSSearchService;
    self.SSUserService = SSUserService;
    self.SSAppService = SSAppService;

    self.PROPERTY_PRODUCT_MARKETING_SUITE_2D = SHOWSUITE.PROPERTY_PRODUCT_MARKETING_SUITE_2D;
    self.PROPERTY_PRODUCT_MARKETING_SUITE_3D = SHOWSUITE.PROPERTY_PRODUCT_MARKETING_SUITE_3D;

    self.PROPERTY_ASSET_TYPE_HERO_IMAGE = SHOWSUITE.PROPERTY_ASSET_TYPE_HERO_IMAGE;
    self.PROPERTY_ASSET_TYPE_LOGO_IMAGE = SHOWSUITE.PROPERTY_ASSET_TYPE_LOGO_IMAGE;

    self.developer_id = SHOWSUITE.data.developer_id;

    self.has_access = false;

    if (self.SSUserService.isDeveloper()) {
        self.init();
        self.has_access = true;
    }
  }

  init() {
    const self = this;

    self.profile = null;

    self.getProfile();
  }

  getProfile() {
    const self = this;

    let url = 'developers/'+ self.developer_id;

    loading(true);
    self.SSHttpService.getAPIRequest(url).then(function (response) {
      loading(false);
      if (response instanceof Error) {
         self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      self.profile = response.data.developer;
      console.log('self.profile');
      console.log(self.profile);
    });
  }

  getPropertyHeroImageUrl(property_assets){
    const self = this;

    if(!property_assets){
      return;
    }

    let asset = property_assets.find(x => x.type == self.PROPERTY_ASSET_TYPE_HERO_IMAGE);

    if(!asset){
      return;
    }

    return self.SSAppService.getAssetUrl(asset.file_uri);
  }

  getPropertyLogoImageUrl(property_assets){
    const self = this;

    if(!property_assets){
      return '/images/placeholder.jpg';
    }

    let asset = property_assets.find(x => x.type == self.PROPERTY_ASSET_TYPE_LOGO_IMAGE);

    if(!asset){
      return '/images/placeholder.jpg';
    }
    
    return self.SSAppService.getAssetUrl(asset.file_uri);
  }

}

DeveloperProfileController.$inject = ['$scope', '$timeout', '$localStorage', 'SSHttpService', 'SSUtilService', 'SSSearchService', 'SSUserService', 'SSAppService'];
app.controller('DeveloperProfileController', DeveloperProfileController);
